import { Navigate } from "@shared/react-router-dom";
import { authRoutes } from "@unauthenticated/shared/data/authRoutes";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";

interface Props {
  isStoreOwner: boolean;
  isPreview: boolean;
  patientAttributes: PatientAttributes;
}

const PatientIntakePage = ({ patientAttributes }: Props) => {
  const { storeSlug } = patientAttributes;

  return <Navigate to={`${authRoutes.welcome_sign_up(storeSlug)}?intake=true`} />;
};

export { PatientIntakePage };
